import {
  ComponentBuilder,
  FunctionComponent
} from '../../component-builder/types';
import { DisplayConfigType } from 'formats/display/lib/config';
import { Component } from './component';

const isBrandBarPriority = (formatConfig: DisplayConfigType) => {
  return formatConfig?.useArrowBtn
    ? formatConfig.brandOrArrowPriority === 'brandOverArrow'
    : true;
};

export class BrandBarBuilder implements ComponentBuilder<DisplayConfigType> {
  isInjectable(adContext: AdContext, formatConfig: DisplayConfigType): boolean {
    return (
      Object.keys(formatConfig?.brand || {}).length > 0 &&
      isBrandBarPriority(formatConfig)
    );
  }

  build(
    adContext: AdContext,
    formatConfig: DisplayConfigType
  ): FunctionComponent {
    return Component;
  }
}
